// drop down value to indicate the outbound call will use the agent's direct line number
export const USE_DIRECT_LINE = 'USE_DIRECT_LINE';
export const DIRECT_LINE = 'DIRECT_LINE';

export const getTenantId = (tenantId: string | null) => {
  if (tenantId === DIRECT_LINE) {
    return null;
  }
  return tenantId;
};
